export const PREFIX = {
  COMMON: 'common',
  MAINTENANCE_DETAIL: 'maintenance_detail',
  WEB: 'web',
} as const

export const EVENT_NAMES = {
  CURRENT: {
    VIEW: 'current_view',
  },
  REFUEL_REPORT: {
    SHOW: 'refuelreportview_show',
    CLICK: 'refuelreportview_click',
  },
  MAINTENANCE_DETAIL: {
    SHOW: 'show',
    CLICK: 'click',
  },
  // 실험 배정. common 접두어와 합쳐져 앱 실험들과 같은 `common_abtest_value`로 적재된다
  AB_TEST: {
    VALUE: 'abtest_value',
  },
  MAINTENANCE_DISTANCE: {
    SHOW: 'maintenance_distance_show',
    CLICK: 'maintenance_distance_click',
  },
  SIMPLE_REFUEL: {
    SHOW: 'diaryinput_simple_show',
    CLICK: 'diaryinput_simple_click',
    UPDATE_FORM: 'diaryinput_simple_update_form',
    DONE: 'diaryinput_simple_done',
  },
  MISSION: {
    SHOW: 'mission_show',
    ITEM_SHOW: 'mission_item_show',
    ITEM_CLICK: 'mission_item_click',
  },
  MONTHLY_REPORT: {
    SHOW: 'web_monthlyReportView_v2_show',
    CLICK: 'web_monthlyReportView_v2_click',
  },
  ZERO_100: {
    PAGE_VIEW: 'webreserve_zero100_pageview',
    CLICK: 'webreserve_zero100_click',
  },
  WEB_VIEW: {
    SEO: {
      SHOW: {
        SEARCH_ITEM: 'webview_search_item_show',
      },
      CLICK: {
        SEARCH_ITEM: 'webview_search_item_click',
      },
      SET: {
        GPS_PERMISSION_SET: 'webview_gps_permission_set',
      },
    },
    COUPON: {
      SHOW: {
        PACKAGE_LANDING_ALERT: 'commerce_package_landing_alert_show',
        PACKAGE_LANDING_ITEM: 'commerce_package_landing_item_show',
      },
      CLICK: {
        PACKAGE_LANDING_ITEM: 'commerce_package_landing_item_click',
      },
    },
  },
  COMMON_WEB_PLACE: {
    PAGE: {
      SHOW: 'common_web_place_page_show',
    },
    SECTION: {
      SHOW: 'common_web_place_section_show',
    },
    ITEM: {
      SHOW: 'common_web_place_item_show',
      CLICK: 'common_web_place_item_click',
      SCROLL: 'common_web_place_item_scroll',
    },
  },
  COMMON_WEB_CAR: {
    PAGE: {
      SHOW: 'common_web_car_page_show',
    },
    SECTION: {
      SHOW: 'common_web_car_section_show',
    },
    ITEM: {
      SHOW: 'common_web_car_item_show',
      CLICK: 'common_web_car_item_click',
      SCROLL: 'common_web_car_item_scroll',
    },
  },
  WEB_RESERVATION: {
    MENU: {
      SHOW: 'webreserve_menu_show',
      CLICK: 'webreserve_menu_click',
    },
    PAYMENT: {
      SHOW: 'webreserve_payment_show',
      COMPLETE_SHOW: 'webreserve_complete_show',
      CLICK: 'webreserve_payment_click',
      COMPLETE_CLICK: 'webreserve_complete_click',
      SUCCESS: 'webreserve_payment_success',
    },
    ENTRY: {
      SHOW: 'webreserve_entry_show',
      CLICK: 'webreserve_entry_click',
    },
    PROFILE: {
      SHOW: 'webreserve_profile_show',
      CLICK: 'webreserve_profile_click',
      SUBMIT: 'webreserve_profile_submit',
    },
    PRODUCT: {
      SHOW: 'webreserve_product_show',
      CLICK: 'webreserve_product_click',
      SUBMIT: 'webreserve_product_submit',
    },
    PLACE: {
      SHOW: 'webreserve_place_show',
      CLICK: 'webreserve_place_click',
      SUBMIT: 'webreserve_place_submit',
    },
    LOGIN: {
      SHOW: 'webreserve_login_show',
      CLICK: 'webreserve_login_click',
    },
  },
}

export const LABELS = {
  CURRENT: {
    SEO: {
      SEARCH_VIEW: 'WebSearchView',
    },
    COUPON: {
      NEW_USER_PACKAGE_LANDING: 'NewUserPackageLanding',
      NEW_USER_PACKAGE_LANDING_ERROR: 'NewUserPackageLandingError',
    },
  },
  REFUEL_REPORT: {
    HEADER: '헤더',
    COMPARE_CHART: '주유통계_이전대비',
    COMPARE_TOGGLE: '이전대비_토글',
    AVERAGE_CHART: '주유통계_평균대비',
    MAINTENANCE_INFO: '정비시기 안내',
    ENGINE_OIL_MAP: '가까운 정비소 확인하기',
    SHARE: '공유하기',
    DETAILING_COUPON: '세차쿠폰발급',
  },
  MAINTENANCE_DETAIL: {
    RESERVATION: '예약하기',
    INTERVAL_SETTING: '주기설정',
    MORE: '더보기',
    INFO: '정보',
    FIRST_MAINTENANCE: '첫 정비 기록하기',
    NEW_MAINTENANCE: '새로운 정비 기록하기',
    FIRST_EXPENSE: '첫 지출 기록하기',
    NEW_EXPENSE: '새로운 지출 기록하기',
    INSPECTION_OPINION: '정비사님 의견 보기',
    CARCARE_TIP_SECTION: '차량관리 팁',
    TREAD_RECORD: '타이어 정비 기록하기',
    // 세차 관리 화면(WEB-5420)
    CARWASH: '세차',
    LOCATION_CHANGE: '위치 변경',
    LOCATION_PERMISSION: '위치 권한',
    CARWASH_DIARY: '세차 기록하기',
    EDIT: '수정',
    REPORT: '리포트',
    REBOOK: '다시 예약',
  },
  WEB_VIEW: {
    SEO: {
      SHOW: {
        SEARCH_ADDRESS: 'search_address',
        SEARCH_KEYWORD_INPUT: 'search_keyword_input',
        COUPON: 'coupon',
        PARTNERS_LIST: 'partners_list',
        ADDRESS_LIST: 'address_list',
        APP_MODAL: 'app_modal',
        REQUEST_PERMISSION: 'request_permission',
        SEARCH_ADDRESS_BOTTOM_SHEET: 'search_address_bottom_sheet',
      },
      CLICK: {
        SEARCH_ADDRESS: 'search_address',
        SEARCH_KEYWORD_INPUT: 'search_keyword_input',
        SEARCH_KEYWORD_INPUT_RESET: 'search_keyword_input_reset',
        SEARCH_ADDRESS_KEYWORD_INPUT: 'search_address_keyword_input',
        SEARCH_ADDRESS_KEYWORD_INPUT_RESET:
          'search_address_keyword_input_reset',
        COUPON: 'coupon',
        PARTNERS_LIST: 'partners_list',
        ADDRESS_LIST: 'address_list',
        CURRENT_LOCATION: 'current_location',
        APP_MODAL_CLOSE: 'app_modal_close',
        APP_MODAL_INSTALL: 'app_modal_install',
      },
      SET: {
        ALLOWED: 'allowed',
        DENIED: 'denied',
      },
    },
    COUPON: {
      SHOW: {
        HAS_HISTORY: 'has_history',
        OUT_OF_PERIOD: 'out_of_period',
        BOTTOM_SHEET: 'bottom_sheet',
        COMMERCE_PRODUCT: 'commerce_product',
        BOTTOM_SHEET_ERROR: 'bottom_sheet_error',
      },
      CLICK: {
        OPEN_BOTTOM_SHEET: 'open_bottom_sheet',
        CLOSE: 'close',
        RETRY: '다시 시도하기',
        COMMERCE_PRODUCT: 'commerce_product',
        BUY: 'buy',
      },
    },
  },
  WEB_RESERVATION: {
    LOGIN: {
      LABEL: '로그인',
      BUTTON: '카카오로 시작하기',
    },
    MENU: {
      LABEL: '메뉴',
      BUTTON_INSTALL: '앱 다운로드',
    },
    PAYMENT: {
      LABEL: '결제',
      BOTTOM_CTA: '결제하기',
      SUCCESS: '결제완료',
    },
    PLACE: {
      LABEL: '업체선택',
      LIST: '업체 리스트',
      EMPTY: '업체없음',
      INFO: '업체정보',
      TIME_SLOT: '타임슬롯',
      AVAILABLE_FROM: '예약가능날짜로이동',
      BOTTOM_CTA: {
        NOT_SELECTED: '시간을 선택해주세요',
        SELECTED: '선택하기',
      },
      IMAGE: '업체 사진',
    },
    ENTRY: {
      LABEL: '시작',
      CTA_BUTTON: '내 차 정보 조회하기',
    },
    PROFILE: {
      LABEL: '차량정보조회',
      BRAND_SELECT: '브랜드선택',
      MODEL_SELECT: '모델선택',
      DETAIL_MODEL_SELECT: '세부모델선택',
      FUEL_SELECT: '유종선택',
      SUBMIT: '차량모델선택완료',
    },
    PRODUCT: {
      LABEL: '상품선택',
      CATALOG: '상품목록',
      UN_SUPPORTED: '지원되지않는차종',
    },
    PRODUCT_INFO: {
      LABEL: '상품영역',
    },
    SORT: {
      BOOKABLE: '예약가능순',
      DISTANCE: '거리순',
      DIARY: '정비이력순',
    },
    MAP: {
      TOGGLE_ON: '지도보기',
      TOGGLE_OFF: '리스트보기',
      MARKER_CLICK: '마커클릭',
      CTA_CLICK: 'CTA클릭',
    },
    LOCATION: {
      CHANGE: '위치변경',
    },
    AUTO_DATE: {
      ADVANCE: '자동날짜이동',
    },
    TOP_NAVIGATION: {
      LABEL: {
        TITLE: '탑내비게이션',
        LOGO: '로고',
        MENU: '메뉴',
        LOCATION_ACCESS: '위치권한_허용',
        LOCATION_ACCESS_DENIED: '위치권한_비허용',
      },
    },
    APP_DOWNLOAD: '마이클 앱 다운로드',
  },
  DATE_PICKER: {
    LABEL: '날짜선택',
  },
  COMMON_WEB_PLACE: {
    PAGE: 'SEO 업체 상세 웹 페이지',
    HERO: '정비소 사진/정보',
    PROMOTION_BANNER: '프로모션 배너',
    PROMOTION_BUTTON: '쿠폰 받기',
    PRODUCT_PRICE: '상품별 가격',
    PERFORMANCE: '이 정비소 시공 실적',
    PERFORMANCE_MORE_BUTTON: '앱에서 시공 후기 자세히 보기',
    REVIEW: '리뷰',
    REVIEW_MORE_BUTTON: '앱으로 편하게 보기',
    TOP_CAR: '이 정비소 TOP 차종',
    SHOP_INFO: '업체 정보',
    NEARBY_SHOP: '주변 정비소',
    NEARBY_SHOP_SCROLL: '업체 스크롤',
    FAQ: '자주 묻는 질문',
    EXPAND: '더보기',
  },
  COMMON_WEB_CAR: {
    PAGE: 'SEO 차종 허브 웹 페이지',
    HERO: '차종 이미지',
    MODEL_INFO: '차종 정보',
    REAL_DEAL_TOOLTIP: '실거래 분석 안내',
    PROMOTION_BANNER_OIL: '엔진오일 프로모션 배너',
    PROMOTION_BANNER_TIRE: '타이어 프로모션 배너',
    PROMOTION_BANNER_OIL_TEXT: '마이클 앱에서 엔진오일 교체 2만원 쿠폰 받기',
    PROMOTION_BANNER_TIRE_TEXT: '마이클 앱에서 타이어 교체 2만원 쿠폰 받기',
    ENGINE_OIL: '마이클 엔진오일 교환',
    TIRE: '마이클 타이어 교체',
    ANNUAL_COST: '연간 정비 비용',
    NEARBY_SHOP: '마이클 정비소',
    NEARBY_SHOP_PERMIT_BUTTON: '허용하기',
    REVIEW: '리뷰',
    REVIEW_MORE_BUTTON: '앱으로 편하게 보기',
    FAQ: '자주 묻는 질문',
    EXPAND: '더보기',
    COLLAPSE: '닫기',
    BOTTOM_CTA_BUTTON: '앱에서 쿠폰 받고 예약하기',
    STICKY_BANNER: '마이클 앱에서 2만원 할인 쿠폰 받기',
  },
  ZERO_100: {
    START: 'start',
    ERROR: 'error',
    BRAND: 'brand',
    BRAND_CLICK: 'brand_click',
    MODEL: 'model',
    MODEL_CLICK: 'model_click',
    MODEL_DETAIL: 'model_detail',
    MODEL_DETAIL_CLICK: 'model_detail_click',
    YEAR_CC: 'year_cc_selection',
    YEAR_CC_NEXT: 'year_cc_next',
    OIL_TYPE: 'oil_type',
    OIL_TYPE_CLICK: 'oil_type_click',
    NAME: 'name',
    NAME_NEXT: 'name_next',
    PHONE_NUMBER: 'phone_number',
    PHONE_NUMBER_NEXT: 'phone_number_next',
    CAR_NUMBER: 'car_number',
    CAR_NUMBER_NEXT: 'car_number_next',
    PRODUCT_SELECTION: 'product_selection',
    PRODUCT_SELECTION_NEXT: 'product_selection_next',
    TIRE_COUNT: 'tire_count',
    TIRE_SIZE: 'tire_size',
    TIRE_WIDTH: 'tire_width',
    TIRE_RATIO: 'tire_ratio',
    TIRE_INCH: 'tire_inch',
    TIRE_PRODUCT_OPTION: 'tire_product_option',
    TIME_TABLE: 'time_table',
    CARD_BENEFIT: 'card_benefit',
    RESERVATION_INFO: 'reservation_info',
    RESERVATION_INFO_NEXT: 'reservation_info_next',
    COMPLETE: 'complete',
    START_BUTTON: '시작하기',
    RETRY_BUTTON: '다시 시도하기',
  },
}

export const CODE = {
  WEB_VIEW: {
    COUPON: {
      NEW_USER_PACKAGE_LANDING_ERROR: 'NewUserPackageLandingError',
      NEW_USER_PACKAGE_LANDING: 'NewUserPackageLanding',
    },
  },
  MAINTENANCE_DETAIL: {
    PAGE: 'page',
    CARCARE_TIP: 'carcare_tip',
    BAR: 'bar',
    DELETE: 'delete',
    INTERVAL_SETTING: 'intervalsetting',
    INTERVAL_INFO: 'intervalinfo',
    RESERVATION: 'reservation',
    INPUT: 'input',
    HISTORY: 'history',
    HISTORY_MORE: 'history_more',
    INSPECTION: 'inspection',
    CYCLE_TAB: 'cycle_tab',
    AVERAGE_INTERVAL: 'average_interval',
    // 예상 트레드(마모도) 관련
    TREAD: 'tread',
    TREAD_GAUGE: 'tread_gauge',
    TREAD_DESC: 'tread_desc',
    TREAD_RECORD: 'tread_record',
    // 세차 관리 화면(WEB-5420) — 새 이벤트 이름을 만들지 않고 이 이벤트에 코드만 더한다
    WASH_INDEX: 'washindex',
    // 세차 지수 설명 아이콘. 지수 자체 클릭과 갈라야 설명을 누른 사람만 셀 수 있다
    // (선례: intervalinfo, tread_desc)
    WASH_INDEX_INFO: 'washindex_info',
    LOCATION: 'location',
    // 지역 선택 화면(별도 창) — 노출과 그 화면 안에서 무엇을 눌렀는지
    LOCATION_PICKER: 'location_picker',
    // 위치를 못 받아 온 것. p_type에 까닭(denied·off·timeout)을 싣는다
    LOCATION_FAIL: 'location_fail',
    // 위치 권한 안내 팝업 노출과 선택
    LOCATION_PERMISSION: 'location_permission',
    DIARY: 'diary',
    EDIT: 'edit',
    REPORT: 'report',
    REBOOK: 'rebook',
    // 화면에 머문 초. p_label에 초, p_type에 보낸 계기(leave·tick)를 싣는다 (WEB-5713)
    DWELL: 'dwell',
  },
  COMMON_WEB_PLACE: {
    PAGE: 'page',
    HERO: 'hero',
    PROMOTION_BANNER: 'promotion_banner',
    PRODUCT_PRICE: 'product_price',
    PERFORMANCE: 'performance',
    REVIEW: 'review',
    TOP_CAR: 'top_car',
    SHOP_INFO: 'shop_info',
    NEARBY_SHOP: 'nearby_shop',
    FAQ: 'faq',
    CTA: 'cta',
  },
  COMMON_WEB_CAR: {
    PAGE: 'page',
    HERO: 'hero',
    MODEL_INFO: 'model_info',
    REAL_DEAL: 'real_deal',
    /** PC sticky 배너 전용. 본문 배너는 유종별로 분리됨 */
    PROMOTION_BANNER: 'promotion_banner',
    PROMOTION_BANNER_OIL: 'promotion_banner_oil',
    PROMOTION_BANNER_TIRE: 'promotion_banner_tire',
    BOTTOM_CTA: 'bottom_cta',
    ENGINE_OIL: 'engine_oil',
    TIRE: 'tire',
    ANNUAL_COST: 'annual_cost',
    NEARBY_SHOP: 'nearby_shop',
    REVIEW: 'review',
    REVIEW_MORE: 'review_more',
    FAQ: 'faq',
  },
  WEB_RESERVATION: {
    MENU: 'menu',
    PAYMENT: 'payment',
    ENTRY: 'entry',
    PLACE: 'place',
    PLACE_LIST: 'placelist',
    PLACE_EMPTY: 'placeempty',
    PLACE_IMAGE: 'placeimage',
    PLACE_SORT: 'placesort',
    PLACE_MAP: 'placemap',
    PLACE_LOCATION: 'placelocation',
    UN_SUPPORTED: 'unsupported',
    BOTTOM_CTA: 'bottomcta',
    BRAND_SELECT: 'brandselect',
    CAR_SELECT: 'carselect',
    MODEL_SELECT: 'modelselect',
    FUEL_SELECT: 'fuelselect',
    PROFILE: 'profile',
    PRODUCT: 'product',
    PRODUCT_INFO: 'productinfo',
    CATALOG: 'catalog',
    TOP_NAVIGATION: 'topnavigation',
    COMPLETE: 'complete',
    INSTALL_BANNER: 'installbanner',
    LOGIN: 'login',
  },
  DATE_PICKER: 'datepicker',
  SIMPLE_REFUEL: 'diaryinput_simple_fillup',
  MISSION: {
    PAGE: 'weekly_mission',
    BUTTON: 'weekly_mission_button',
    TICKET: 'weekly_mission_ticket',
    ROULETTE: 'weekly_mission_roulette',
  },
}

export const TYPE = {
  PAGE: 'page',
  SECTION: 'section',
  BUTTON: 'button',
  GAUGE: 'gauge',
  TEXT: 'text',
  ITEM: 'item',
  LIST_ITEM: 'list_item',
  MAINTENANCE_DETAIL: {
    MILEAGE: 'mileage',
    DAY: 'day',
    FIRST: 'first',
    ADD: 'add',
    SELF: 'self',
    REPORT: 'report',
    // 세차 관리 화면(WEB-5420) — 기록 추가 줄이 목록 위에 있는지 빈 화면에 있는지
    LIST: 'list',
    EMPTY: 'empty',
    // 지역 선택 화면 — 지역을 무엇으로 골랐는지
    CURRENT: 'current',
    SEARCH: 'search',
    RECENT: 'recent',
    // 지역 선택 화면·권한 팝업 — 고르지 않고 닫았는지, 팝업에서 넘어갔는지
    CLOSE: 'close',
    CONFIRM: 'confirm',
    // 위치를 못 받아 온 까닭
    DENIED: 'denied',
    OFF: 'off',
    TIMEOUT: 'timeout',
  },
  BUTTON_CTA: 'button_cta',
  CHIP: 'chip',
  LOCATION_BUTTON: 'location_button',
  BUTTON_INSTALL: 'button_install',
  BUTTON_ITEM: 'button_item',
  BUTTON_DATE: 'button_date',
  BUTTON_LOGO: 'button_logo',
  BUTTON_MENU: 'button_menu',
  BUTTON_DETAIL: 'button_detail',
  BUTTON_TIME_SLOT: 'button_timeslot',
  BUTTON_AVAILABLE_FROM: 'button_availablefrom',
  BUTTON_LOGIN: 'button_login',
  VALUE_SUBMIT: 'value_submit',
  VALUE_SUCCESS: 'value_success',
  FILTER_LOCATION: 'filter_location',
  FILTER_SORT: 'filter_sort',
  BUTTON_MAP_TOGGLE: 'button_maptoggle',
  BUTTON_LOCATION_CHANGE: 'button_locationchange',
  BUTTON_MAP_MARKER: 'button_mapmarker',
  BUTTON_MAP_CTA: 'button_mapcta',
  AUTO_DATE_ADVANCE: 'auto_dateadvance',
  IMAGE: 'image',
  CARD: 'card',
  BANNER: 'banner',
  TOOLTIP: 'tooltip',
  PLACE: {
    ITEM: 'item_place',
  },
  REFUEL_REPORT: {
    SHARE_TOP: '공유하기_상단',
    SHARE_KAKAO: '공유하기_카카오톡',
    SHARE_URL: '공유하기_url',
    SHARE_MORE: '공유하기_더보기',
    FUEL_EFFICIENCY: '연비',
    GAS_PRICE: '주유비',
    ENGINE_OIL_REPLACEMENT: '엔진오일 교체시기',
  },
}

export const STATUS = {
  SELECTED: 'selected',
  UNSELECTED: 'unselected',
  DISABLED: 'disabled',
  ENABLED: 'enabled',
  ON: 'on',
  OFF: 'off',
  OPEN: 'open',
  CLOSED: 'closed',
}

export const FROM = {
  MOBILE: 'mobile',
  /** PC 본문 지면. 우측 sticky 카드는 DESKTOP_STICKY로 따로 집계한다 */
  DESKTOP: 'desktop',
  DESKTOP_STICKY: 'desktop_sticky',
  MENU: 'menu',
  PLACE: 'place',
  REFUEL_REPORT_SHARE: 'web_RefuelReportShare',
}

export const TARGETS = {
  REFUEL_REPORT: {
    FIRST_REFUEL: 'first_refuel',
    REPEAT_REFUEL: 'repeat_refuel',
  },
}

export const MODES = {
  REFUEL_REPORT: {
    COUPON: 'coupon',
    MAP: 'map',
    REVIEW: 'review',
  },
}
